var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#star_svg__a)",
    d: "M7.158 1.65C7.374.74 8.605.59 9.033 1.421l2.129 4.138c.134.262.376.451.662.52l4.527 1.078c.91.216 1.059 1.447.227 1.875L12.44 11.16a1 1 0 0 0-.52.663l-1.077 4.527c-.217.91-1.448 1.058-1.876.227L6.84 12.44a1 1 0 0 0-.662-.52L1.65 10.843c-.91-.216-1.06-1.447-.228-1.875L5.561 6.84c.261-.135.45-.377.519-.663z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4A4A4A",
    strokeLinejoin: "round",
    strokeOpacity: 0.09,
    d: "M7.644 1.765a.507.507 0 0 1 .945-.114l2.128 4.138c.201.39.563.675.99.777l4.528 1.078c.458.11.533.73.114.945l-4.138 2.128c-.39.201-.674.563-.776.99l-1.079 4.527a.507.507 0 0 1-.944.115L7.283 12.21a1.5 1.5 0 0 0-.99-.776l-4.528-1.079a.507.507 0 0 1-.114-.944l4.138-2.129c.391-.2.675-.563.777-.991z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "star_svg__a",
    x1: 3.958,
    x2: 15.057,
    y1: 1.375,
    y2: 16.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25C770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EF3B"
  })))));
};
export default SvgStar;